import { navigate } from 'gatsby'
import { useMount } from 'ahooks'
import { routes } from 'config'

// markup
const IndexPage = (): JSX.Element => {
  useMount(() => {
    navigate(routes.login)
  })

  return <></>
}

export default IndexPage
